<template>
  <div class="common__main-contener">
    <div class="lesson-date">
      <h5 class="font-weight-bold mb-3">To-do list</h5>
    </div>
    <div class="scroll-area">
      <div v-if="todoList.length > 0">
        <div
          class="information__description"
          v-for="todo of todoList"
          :key="todo.id"
        >
          <div class="mr-2">{{todo.expired | ymd}}</div>
          <router-link
            v-if="todo.type === 'frs'"
            :to="{
              name: 'FinalReviewSheetEdit',
              params: {lessonId: todo.lesson.id},
            }"
            class="information__description-Lesson"
          >
            {{todo.lesson | FrslessonName}}
          </router-link>
          <router-link
            v-if="todo.type === 'classRecord'"
            :to="{
              name: 'ClassRecordEdit',
              params: {lessonId: todo.lesson.id},
            }"
            class="information__description-Lesson"
          >
            {{todo.lesson | lessonName}}
          </router-link>
          <b-badge v-if="todo.isWaitingApproved === true" pill variant="info" class="status">
            pending approval
          </b-badge>
        </div>
      </div>
      <div v-else>
        <h6>There are no todo</h6>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import moment, { Moment } from 'moment'
import { Lesson } from '@/store/deadlines/types'
import _ from 'lodash'

@Component({
  filters: {
    lessonName(l: Lesson) {
      return `${l.level.code} Period ${l.period} (${l.dayofweek}) Unit ${l.unit}`
    },
    FrslessonName(l: Lesson) {
      return `${l.level.code} Period ${l.period} (${l.dayofweek}) Unit ${l.unit} FRS`
    },
    ymd(date: Moment) {
      return moment(date, 'YYYYMMDDHHmmss').format('YYYY/MM/DD')
    },
  },
})

export default class ToDoDeadlineComponent extends Vue {
  private created() {
    this.$store.dispatch('fetchToDoDeadlines', this.$store.state.auth.profile.id);
  }

  private get todoList() {
    const todoList = _.chain(this.$store.state.mypage.toDoDeadlines)
      .filter(({ lesson }) => {
        return lesson.datetime.isBefore(moment(), 'minute');
      })
      .orderBy('expired', 'asc')
      .value();
    return todoList;
  }
}
</script>

<style scoped>
.information__description {
  display: flex;
  padding-left:20px;
}

.information__description-Lesson {
  margin-right:10px;
}

.information__description:not(:last-child) {
  margin-bottom: 10px;
}

.scroll-area {
  height:200px;
  overflow-y: scroll;
}

.status {
  line-height: unset;
}

/*スクロールバー全体*/
::-webkit-scrollbar {
    width: 15px;
}

/*スクロールバーの軌道*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 3px rgba(0, 0, 0, .1);
  border: 1px solid #B0C4DE;
}

/*スクロールバーの動く部分*/
::-webkit-scrollbar-thumb {
  background-color: #B0C4DE;
}
</style>
